import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

export default function Search({ universities, onChange }) {
  const [selected, setSelected] = useState("");

  function handleClick(university) {
    setSelected(university);
    onChange(university);
  }

  return (
    <div className={styles.container}>
      <span
        onClick={() => handleClick("")}
        className={selected === "" && styles.selected}
      >
        Everyone
      </span>
      {universities.map(university => (
        <span
          onClick={() => handleClick(university)}
          className={selected === university && styles.selected}
        >
          {university}
        </span>
      ))}
    </div>
  );
}

Search.propTypes = {
  universities: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};
